import { Injectable } from "@angular/core";
import { SepaQrTileData } from "@modules/main/components/sepa-qr-new/sepa-qr-tile-new/models/sepa-qr-tile-data.model";
import { TranslationService } from "@core-services/translation.service";
import { Sepa } from "@models";

@Injectable()
export class SepaQrFacade {
	public constructor(private readonly translationService: TranslationService) {}

	public getReferenceNumberTilesData(paymentReference: string): SepaQrTileData[] {
		return [
			{
				label: this.translationService.translate("reference_code"),
				value: paymentReference,
				valueToCopy: paymentReference,
				copyInfo: this.translationService.translate("copied_reference_to_clipboard")
			}
		];
	}

	public getSepaQrTilesData(sepa: Sepa, isGBPBankTransfer: boolean): SepaQrTileData[] {
		if (!sepa) {
			return [];
		}

		if (isGBPBankTransfer) {
			return this.getGBPTilesData(sepa);
		}
		return this.getNonGBPTilesData(sepa);
	}

	private getGBPTilesData(sepa: Sepa): SepaQrTileData[] {
		return [
			...this.getSharedTilesData(sepa),
			{
				label: this.translationService.translate("sepa_account_number"),
				value: sepa?.getAccountNumber(),
				valueToCopy: sepa?.getAccountNumber(),
				copyInfo: this.translationService.translate("copied_sepa_account_number_to_clipboard")
			},
			{
				label: this.translationService.translate("sepa_sort_code"),
				value: sepa?.getSortCode(),
				valueToCopy: sepa?.getSortCode(),
				copyInfo: this.translationService.translate("copied_sepa_sort_code_to_clipboard")
			}
		];
	}

	private getNonGBPTilesData(sepa: Sepa): SepaQrTileData[] {
		return [
			...this.getSharedTilesData(sepa),
			{
				label: this.translationService.translate("iban"),
				value: sepa?.getIban(),
				valueToCopy: sepa?.getIban(),
				copyInfo: this.translationService.translate("copied_iban_to_clipboard")
			},
			{
				label: this.translationService.translate("bic_payout_account_field"),
				value: sepa?.getBic(),
				valueToCopy: sepa?.getBic(),
				copyInfo: this.translationService.translate("copied_sepa_bic_to_clipboard")
			}
		];
	}

	private getSharedTilesData(sepa: Sepa): SepaQrTileData[] {
		return [
			{
				label: this.translationService.translate("recipient"),
				value: sepa?.getReceiver(),
				valueToCopy: sepa?.getReceiver(),
				copyInfo: this.translationService.translate("copied_sepa_recipient_to_clipboard")
			}
		];
	}
}
